import { createFileRoute } from "@tanstack/react-router";
import { DocumentosPage } from "@/features/documentos/components/DocumentosPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/documentos")({
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: DocumentosPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
